<mf-page title="Transferencias">
  <mf-transfer-grid
    [accreditationOriginNumber]="accreditationOriginNumber"
    [accreditationConsolidationNumber]="accreditationConsolidationNumber" />
</mf-page>
